import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notification, NotificationsState } from '../../helpers/types';

const initialState: NotificationsState = {
  data: [],
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.data = [action.payload, ...state.data].slice(0, 1000);
    },
    clearAllNotifications: state => {
      state.data = [];
    },
  },
});

export const { addNotification, clearAllNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
